import { defineComponent as h, ref as c, provide as u, openBlock as p, createElementBlock as d, renderSlot as _, inject as i, computed as v, watchEffect as w, normalizeClass as r, createElementVNode as l, unref as C, createCommentVNode as N, toDisplayString as S } from "vue";
import { gsap as f } from "gsap";
import './assets/index2.css';const $ = { class: "Accordion" }, T = /* @__PURE__ */ h({
  __name: "Accordion",
  props: {
    selectedIndex: { default: -1 },
    autoCollapsable: { type: Boolean, default: !0 },
    showNumbers: { type: Boolean, default: !1 }
  },
  setup(m) {
    const o = m, a = c([]);
    return u("itemsStates", a), u("autoCollapsable", o.autoCollapsable), u("showNumbers", o.showNumbers), (t, n) => (p(), d("ul", $, [
      _(t.$slots, "default")
    ]));
  }
});
const k = ["innerHTML"], x = { class: "Accordion__title" }, B = /* @__PURE__ */ l("div", { class: "Accordion__space" }, null, -1), L = /* @__PURE__ */ h({
  __name: "AccordionItem",
  props: {
    title: { default: "" }
  },
  setup(m) {
    const o = c(null), a = c(null), t = c(0), n = i("itemsStates"), A = i("autoCollapsable"), O = i("showNumbers"), s = v(() => n.value[t.value]);
    (() => {
      t.value = n.value.length, n.value.push({
        index: t.value,
        isOpen: !1
      });
    })();
    const b = v(() => {
      const e = t.value + 1;
      switch (e.toString().slice(-1)) {
        case "1":
          return `#${e}<sup>st</sup>`;
        case "2":
          return `#${e}<sup>nd</sup>`;
        case "3":
          return `#${e}<sup>rd</sup>`;
        default:
          return `#${e}<sup>th</sup>`;
      }
    }), g = () => {
      A && n.value.forEach((e) => {
        e.index !== t.value && (e.isOpen = !1);
      }), n.value[t.value].isOpen = !s.value.isOpen;
    };
    return w(() => {
      if (!o.value || !a.value)
        return;
      const e = 24e-4 * o.value.scrollHeight;
      f.to(o.value, {
        duration: e,
        height: s.value.isOpen ? "auto" : "0px",
        opacity: s.value.isOpen ? 1 : 0,
        ease: "ease.inOut"
      }), f.to(a.value, {
        duration: e / 2,
        marginTop: s.value.isOpen ? 16 : 0,
        marginBottom: s.value.isOpen ? 16 : 0,
        ease: "ease.inOut"
      });
    }), (e, y) => (p(), d("li", {
      ref_key: "item",
      ref: a,
      class: r(["Accordion__item", { "Accordion__item--open": s.value.isOpen }])
    }, [
      l("button", {
        class: "Accordion__headline",
        onClick: g
      }, [
        C(O) ? (p(), d("div", {
          key: 0,
          class: "Accordion__number",
          innerHTML: b.value
        }, null, 8, k)) : N("", !0),
        _(e.$slots, "headline", {}, () => [
          l("div", x, S(e.title), 1),
          B
        ]),
        l("div", {
          class: r(["Accordion__arrow", { "Accordion__arrow--open": s.value.isOpen }])
        }, null, 2)
      ]),
      l("div", {
        ref_key: "content",
        ref: o,
        class: r(["Accordion__content", { "Accordion__content--fadeOut": !s.value.isOpen }]),
        style: { height: "0px" }
      }, [
        _(e.$slots, "content")
      ], 2)
    ], 2));
  }
});
export {
  T as Accordion,
  L as AccordionItem
};
